// extracted by mini-css-extract-plugin
module.exports = {"link":"Breadcrumbs_link__2HpGP"};